module.exports = __webpack_public_path__ + "2c2f52dd42491d3bc9ad21bccf3a9b3b.pdf";